import { CONTROLLER, METHOD } from 'common/config/endpoint.config';
import { ApiMethods } from 'common/enums/api-methods.enum';
import { ApiConfig } from 'common/models/api-service/api-config.model';

const userConfig = {
    getUserInfoUrl: (): ApiConfig =>
        new ApiConfig(`${CONTROLLER.USER}/${METHOD.USER.GET_USER_INFO}`, ApiMethods.GET),
    getFeatures: (): ApiConfig =>
        new ApiConfig(`${CONTROLLER.USER}/${METHOD.USER.GET_FEATURES_AND_ACTIONS}`)
};

export default userConfig;
